import {Container, ContainerItem} from "../common/container/Container";
import {
    DIRECT_TESTING_API_KEY, DIRECT_TESTING_MODULE,
    DIRECT_TESTING_SERVICE_KEY,
    DirectTestingProps
} from "../modules/directTesting/container";
import {DirectTestingService} from "../modules/directTesting/services/DirectTestingService";
import {DirectTestingApi} from "../modules/directTesting/api/directTestingApi";
import {getAppContainer} from "./app";
import {moduleURLs} from "../config/api";


let container: Container

function init(p: DirectTestingProps) {
    const items = new Map<symbol, ContainerItem>()

    items.set(DIRECT_TESTING_API_KEY, new ContainerItem({ instance: new DirectTestingApi() }))
    items.set(
        DIRECT_TESTING_SERVICE_KEY,
        new ContainerItem({
            instance: new DirectTestingService({ apiKey: DIRECT_TESTING_API_KEY }),
        })
    )

    container = new Container(items, p.DirectTestingContainer, p.config)
}

export function getDirectTestingContainer(): Container {
    if (!container) {
        init({
            DirectTestingContainer: getAppContainer(),
            config: {
                moduleFullUrlDirectTesting: moduleURLs[DIRECT_TESTING_MODULE],
            },
        })
    }

    return container
}